import { _axios } from '@/plugins/axios';

const sbomResource = '/api/v1/sbom';

export default {
  all: () => _axios.get(`${sbomResource}/files`),
  create: sbom => _axios.post(`${sbomResource}/create`, sbom),
  delete: filename => _axios.delete(`${sbomResource}/files/${filename}`),
  update: sbom => _axios.put(`${sbomResource}/update`, sbom),
  getById: id => _axios.get(`${sbomResource}/${id}`),
  upload: formData =>
    _axios.post(`${sbomResource}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  validate: sbom => _axios.post(`${sbomResource}/validate`, sbom),
  getComponents: id => _axios.get(`${sbomResource}/${id}/components`),
  getFiles: () => _axios.get(`${sbomResource}/files`),
  getFileSize: filename => _axios.get(`${sbomResource}/size/${filename}`),
  downloadFile: filename =>
    _axios.get(`${sbomResource}/files/${filename}/download`, {
      responseType: 'text',
    }),
  deleteFile: filename => _axios.delete(`${sbomResource}/files/${filename}`),
  deleteAllFiles: () => _axios.delete(`${sbomResource}/files`),
  processAllFiles: () => _axios.post(`${sbomResource}/vimpact/process-all`),
  processFile: filename =>
    _axios.post(`${sbomResource}/vimpact/process/${encodeURIComponent(filename)}`),
  enrichFile: filename => _axios.post(`${sbomResource}/enrich/${encodeURIComponent(filename)}`),
  processSelectedFiles: filenames => _axios.post(`/api/cve/process-selected`, { filenames }),
  getVimpactOutputFiles: () => _axios.get(`${sbomResource}/vimpact/output/files`),
  getOrganizedVimpactOutputFiles: () =>
    _axios.get(`${sbomResource}/vimpact/output/files/organized`),
  downloadVimpactOutputFile: filePath =>
    _axios.get(`${sbomResource}/vimpact/output/files/download/${encodeURIComponent(filePath)}`, {
      responseType: 'blob',
    }),
  deleteAllVimpactOutputFiles: () => _axios.delete(`${sbomResource}/vimpact/output/files`),
};
